import MotoristaService from "@/services/MotoristaService";

export const motorista = {
  namespaced: true,
  state: {
    motorista: {},
  },
  actions: {
    getMotorista({ commit }, payload) {
      return MotoristaService.GetMotorista(payload).then(
        (motorista) => {
          return Promise.resolve(motorista);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMotorista({ commit }, payload) {
      return MotoristaService.PostMotorista(payload).then(
        (motorista) => {
          return Promise.resolve(motorista);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putMotorista({ commit }, payload) {
      return MotoristaService.PutMotorista(payload).then(
        (motorista) => {
          return Promise.resolve(motorista);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteMotorista({ commit }, payload) {
      return MotoristaService.DeleteMotorista(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getMotoristaOData({ commit }, payload) {
      return MotoristaService.GetMotoristaOData(payload).then(
        (motorista) => {
          return Promise.resolve(motorista);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default motorista;
